export default __webpack_public_path__ + "static/media/control.270775bc.svg";